"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubProvider = void 0;
/* eslint-disable new-cap */
/* eslint-disable no-console */
const signalr_1 = require("@microsoft/signalr");
const react_1 = __importStar(require("react"));
const DefaultHubRetryPolicy_1 = __importDefault(require("./DefaultHubRetryPolicy"));
const HubContext_1 = require("./HubContext");
const HubProvider = ({ children, configuration }) => {
    const { hubDefinitions, isEnabled, accessTokenFactory, isDebug } = configuration;
    const [hubService, setHubService] = (0, react_1.useState)(new HubContext_1.HubService({}));
    const [hubManagers, setHubManagers] = (0, react_1.useState)({});
    const connections = (0, react_1.useRef)({});
    (0, react_1.useEffect)(() => {
        const managers = {};
        if (isEnabled && (accessTokenFactory === null || accessTokenFactory === void 0 ? void 0 : accessTokenFactory())) {
            hubDefinitions.forEach((definition) => {
                const { factory, url, authorization, handlers } = definition;
                const { id } = factory;
                if (hubManagers[id]) {
                    const { connection, isConnected } = hubManagers[id];
                    const hub = new factory(id, connection, isDebug, authorization);
                    const manager = { definition, connection, hub, isConnected };
                    managers[id] = manager;
                }
                else {
                    const newConnection = new signalr_1.HubConnectionBuilder()
                        .configureLogging(isDebug ? signalr_1.LogLevel.Information : signalr_1.LogLevel.Error)
                        .withUrl(url, {
                        accessTokenFactory: () => { var _a; return (_a = accessTokenFactory()) !== null && _a !== void 0 ? _a : ''; },
                    })
                        .withAutomaticReconnect(new DefaultHubRetryPolicy_1.default())
                        .build();
                    connections.current[id] = newConnection;
                    newConnection.onreconnecting(() => {
                        var _a;
                        if (isDebug) {
                            console.log(`[SignalR] Reconnecting to ${id}`);
                        }
                        setHubManagers((m) => {
                            const updated = Object.assign({}, m);
                            if (updated[id]) {
                                const manager = Object.assign(Object.assign({}, updated[id]), { isConnected: false });
                                updated[id] = manager;
                            }
                            return updated;
                        });
                        (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onReconnecting) === null || _a === void 0 ? void 0 : _a.call(handlers);
                    });
                    newConnection.onreconnected(() => {
                        var _a;
                        if (isDebug) {
                            console.log(`[SignalR] Reconnected to ${id}`);
                        }
                        setHubManagers((m) => {
                            const updated = Object.assign({}, m);
                            if (updated[id]) {
                                const manager = Object.assign(Object.assign({}, updated[id]), { isConnected: true });
                                updated[id] = manager;
                            }
                            return updated;
                        });
                        (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onReconnected) === null || _a === void 0 ? void 0 : _a.call(handlers);
                    });
                    newConnection.onclose(() => {
                        var _a;
                        if (isDebug) {
                            console.log(`[SignalR] ${id} connection closed`);
                        }
                        (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onClose) === null || _a === void 0 ? void 0 : _a.call(handlers);
                    });
                    newConnection
                        .start()
                        .then(() => {
                        var _a;
                        if (isDebug) {
                            console.log(`[SignalR] ${id} connection established`);
                        }
                        setHubManagers((m) => {
                            const updated = Object.assign({}, m);
                            if (updated[id]) {
                                const manager = Object.assign(Object.assign({}, updated[id]), { isConnected: true });
                                updated[id] = manager;
                            }
                            return updated;
                        });
                        (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onConnectionStarted) === null || _a === void 0 ? void 0 : _a.call(handlers);
                    })
                        .catch((err) => {
                        var _a;
                        if (isDebug) {
                            console.log(`[SignalR] ${id} connection error ${err}`);
                        }
                        setHubManagers((m) => {
                            const updated = Object.assign({}, m);
                            if (updated[id]) {
                                delete updated[id];
                            }
                            return updated;
                        });
                        (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onConnectionFailed) === null || _a === void 0 ? void 0 : _a.call(handlers);
                    });
                    const hub = new factory(id, newConnection, isDebug, authorization);
                    const manager = { definition, connection: newConnection, hub, isConnected: false };
                    managers[id] = manager;
                }
            });
        }
        Object.values(hubManagers)
            .filter((x) => !Object.values(managers).some((n) => n.definition.factory.id === x.definition.factory.id))
            .forEach((toDispose) => {
            toDispose.connection.stop();
            delete connections.current[toDispose.definition.factory.id];
        });
        setHubManagers(managers);
    }, [configuration]);
    (0, react_1.useEffect)(() => {
        setHubService(new HubContext_1.HubService(hubManagers));
    }, [hubManagers]);
    (0, react_1.useEffect)(() => () => {
        Object.values(connections.current).forEach((connection) => {
            connection.stop();
        });
    }, []);
    return react_1.default.createElement(HubContext_1.HubContext.Provider, { value: hubService }, children);
};
exports.HubProvider = HubProvider;
